export default __webpack_public_path__ + "static/media/davos.f30ab886.jpg";